import gsap from 'gsap';

const init = () => {
  const gnavItems = document.querySelectorAll('.js-gnavItem');
  if (!gnavItems) return;

  gnavItems.forEach(item => {
    item.addEventListener('click', (e) => {
      const windowWidth = window.innerWidth;
      if (windowWidth > 992) return; // Only for mobile
      e.preventDefault();
      e.stopPropagation();
      const subMenu = item.nextElementSibling;
      if (!subMenu) return;

      const status = item.getAttribute('data-open');
      if (status === 'true') {
        item.setAttribute('data-open', 'false');
        gsap.to(subMenu, {
          height: 0,
          duration: 0.3,
          ease: "power1.inOut",
        });
      } else {
        item.setAttribute('data-open', 'true');
        const subMenuHeight = subMenu.scrollHeight;
        gsap.to(subMenu, {
          height: subMenuHeight,
          duration: 0.3,
          ease: "power1.inOut",
        });
      }
    });
  });
}

export {
  init
}